<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" color="tertiary">
                    <v-toolbar color="secondary" dark flat>
                        <v-toolbar-title>{{
                            $t('forgotPasswordView.title')
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                        <v-form class="mb-3" @submit.prevent="onSubmit">
                            <v-text-field
                                id="email"
                                v-model="email"
                                :label="$t('forgotPasswordView.email')"
                                prepend-icon="$person"
                                type="email"
                                color="secondary"
                                error-count="2"
                                required
                                :error-messages="emailErrors"
                                :disabled="emailSentConfirmationVisible"
                                @input="
                                    $v.email.$touch();
                                    clearServerErrors('email');
                                "
                                @blur="$v.email.$touch()"
                            />
                        </v-form>
                        <p
                            v-if="emailSentConfirmationVisible"
                            class="green--text"
                        >
                            <span class="text-h6">{{
                                $t('forgotPasswordView.emailSentTitle')
                            }}</span>
                            <br />
                            {{ $t('forgotPasswordView.emailSentMessage') }}
                        </p>
                    </v-card-text>
                    <v-card-actions class="pa-4">
                        <router-link :to="{ name: 'login' }">
                            {{ $t('forgotPasswordView.backToLogin') }}
                        </router-link>
                        <v-spacer />
                        <v-btn
                            class="elevation-0"
                            large
                            color="secondary"
                            :disabled="!isValid || emailSentConfirmationVisible"
                            @click="onSubmit"
                            >{{ $t('forgotPasswordView.sendButton') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import forgotPasswordEmailValidatorMixin from '@/validators/auth/forgotPasswordEmailValidator.mixin';

export default {
    name: 'forgotPasswordView',
    mixins: [forgotPasswordEmailValidatorMixin],
    data() {
        return {
            email: '',
            emailSentConfirmationVisible: false
        };
    },
    methods: {
        ...mapActions({ requestPasswordReset: 'auth/requestPasswordReset' }),

        async onSubmit() {
            try {
                this.$v.$touch();

                if (!this.isValid) {
                    return;
                }

                await this.requestPasswordReset(this.email);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('forgotPasswordView.emailSentTitle'),
                    text: this.$t('forgotPasswordView.emailSentMessage')
                });

                this.emailSentConfirmationVisible = true;
            } catch (error) {
                if (this.checkForServerFormErrors(error)) {
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t('forgotPasswordView.title'),
                        text: this.$t('forgotPasswordView.checkFormErrors')
                    });
                }

                console.error(error);
            }
        }
    }
};
</script>
